export default __webpack_public_path__ + "static/media/avascript-logo.10ac3efc.svg";